module.exports = __webpack_public_path__ + "static/womanandchild-b411294f23472df165dc05543db9b52c.jpg";